export const ALL_TIME_HIGH_LOW = "ALL_TIME_HIGH_LOW";
export const ALL_TIME_HIGH_LOW_STREAM = "ALL_TIME_HIGH_LOW_STREAM";
